import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import HeadData from 'components/Common/HeadData'
import LayoutContainer from 'components/Common/LayoutContainer'
import LineExclamationCircleIcon from 'components/Luxkit/Icons/line/LineExclamationCircleIcon'
import TextButton from 'components/Luxkit/Button/TextButton'
import Heading from 'components/Luxkit/Typography/Heading'

const Root = styled.div`
  position: relative;
  overflow: hidden;
  line-height: 1.5;
  text-align: center;
`

const IconHeading = styled(LineExclamationCircleIcon)`
  color: ${({ theme }) => theme.palette.neutral.one};
  height: ${rem(39)};
  width: ${rem(39)};
  margin: 0 auto ${rem(22)};
`

const TextHeading = styled(Heading)`
  height: ${rem(45)};
  max-width: ${rem(700)};
  margin: 0 auto ${rem(22)};
`

const TextDescription = styled(Heading)`
  height: ${rem(66)};
  max-width: ${rem(700)};
  margin: 0 auto ${rem(22)};
`

const Wrapper = styled.div`
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${rem(328)};
`

const ImageWrapper = styled.div`
  width: 100%;
  max-height: calc(100vh - ${rem(386)});
  display: flex;
  align-items: center;
  overflow: hidden;
`

const ImageContent = styled.div`
  position: absolute;
  z-index: 1;
  top: ${rem(486)};
  bottom: 0;
  left: 0;
  right: 0;
`

function Error500Page() {
  return (
    <Root className="Error500Page T-Error500Page">
      <HeadData
        title="Page Not Available"
        description="500 - fatal error"
        noIndex
      />
      <Wrapper>
        <IconHeading />
        <TextHeading variant="heading2" align="center" forwardedAs="h1">
          Oh no, an error has occurred
        </TextHeading>
        <TextDescription variant="heading3" align="center" forwardedAs="h2"
        >
          There seems to be a problem on our end. Rest assured our team is working hard to repair it and all should be fixed soon.
        </TextDescription>
        <ImageContent>
          <LayoutContainer>
            <TextHeading variant="heading2" align="center" colour="neutral-four">
              Luxury Escapes Magazine
            </TextHeading>
            <TextDescription variant="heading3" align="center" colour="neutral-four">
              In the meantime check out our magazine for the latest travel videos &amp; guides
            </TextDescription>
            <TextButton
              kind="primary"
              href="http://www.luxuryescapes.com/magazine"
              target="_blank"
            >
              View Magazine
            </TextButton>
          </LayoutContainer>
        </ImageContent>
      </Wrapper>
      <ImageWrapper>
        <ResponsiveImage
          aria-hidden="true"
          alt="Page Not Available"
          brightness={-35}
          xs="8:9" sm="4:3" md="4:3" lg="16:9" xl="21:9"
          id="nqoj6awjm2cqbghnnaor"
        />
      </ImageWrapper>
    </Root>
  )
}

export default React.memo(Error500Page)
